import { render, staticRenderFns } from "./PhotoCard.vue?vue&type=template&id=044e8279"
import script from "./PhotoCard.vue?vue&type=script&lang=js"
export * from "./PhotoCard.vue?vue&type=script&lang=js"
import style0 from "./PhotoCard.vue?vue&type=style&index=0&id=044e8279&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports